import { Link } from 'react-router-dom';
import { comics, hotRankings } from '@/mocks/comics';

export default function HotSection() {
  const featured = comics.slice(0, 6);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-10">
          <div className="lg:w-2/3">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门推荐</h2>
              <Link to="/category/shaonian" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer">
                查看更多 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-5" data-product-shop="">
              {featured.map((comic) => (
                <Link
                  key={comic.id}
                  to={`/article/${comic.id}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
                >
                  <div className="relative aspect-[3/4] overflow-hidden">
                    <img
                      src={comic.cover}
                      alt={`${comic.title} 漫画封面`}
                      title={`${comic.title} - 女神漫画网高清免费阅读`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-2 left-2">
                      <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                        comic.status === '连载中'
                          ? 'bg-accent-500/90 text-background-50'
                          : 'bg-foreground-500/80 text-background-50'
                      }`}>
                        {comic.status}
                      </span>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                      <div className="flex items-center gap-1 text-background-50 text-xs">
                        <i className="ri-star-fill text-accent-400 text-xs"></i>
                        <span>{comic.rating}</span>
                      </div>
                    </div>
                  </div>
                  <div className="p-3 md:p-4">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
                    <div className="flex items-center gap-1 mt-2">
                      {comic.tags.slice(0, 2).map((tag) => (
                        <span key={tag} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-1/3">
            <div className="sticky top-20">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">人气排行</h2>
                <span className="text-xs text-foreground-500">本周数据</span>
              </div>

              <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
                {hotRankings.map((item, idx) => (
                  <Link
                    key={item.id}
                    to={`/article/${item.id}`}
                    className={`flex items-center gap-3 px-4 py-3 hover:bg-background-100 transition-colors cursor-pointer ${
                      idx < hotRankings.length - 1 ? 'border-b border-background-200/70' : ''
                    }`}
                  >
                    <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                      item.rank <= 3
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                    }`}>
                      {item.rank}
                    </span>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-foreground-800 truncate">{item.title}</p>
                    </div>
                    <div className="flex items-center gap-1 flex-shrink-0">
                      <span className="text-xs text-foreground-500">{item.views}</span>
                      <i className={`text-xs ${item.trend === 'up' ? 'text-accent-500 ri-arrow-up-line' : 'text-foreground-400 ri-arrow-down-line'}`}></i>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}